import { gql } from '@apollo/client/core';
import { useApolloClient, useMutation } from '@vue/apollo-composable';
import type { ComputedRef } from 'vue';
import { computed, ref } from 'vue';

const SWITCH_SCOPE = gql`
  mutation switchRoleMutation($scope: string) {
    switchScope(scope: $scope)
      @rest(method: "GET", path: "Login/WisselLoginRol?loginRol={args.scope}") {
      result
    }
  }
`;

export default function useSwitchScope(): {
  loading: ComputedRef<boolean>;
  switchScope: (id: string) => Promise<void>;
} {
  const { mutate } = useMutation<{ scope: string }>(SWITCH_SCOPE);
  const { client } = useApolloClient();

  const loading = ref(false);

  const switchScope = async (scope: string) => {
    loading.value = true;
    await mutate({ scope: encodeURIComponent(scope) });
    await client.resetStore();
    loading.value = false;
  };

  return {
    loading: computed(() => loading.value),
    switchScope,
  };
}
